// Copyright © 2021 Move Closer
import { computed } from '@vue/composition-api';
import { abstractModalProps, useModal } from '../../_abstract';
import { ModalMode } from './Modal.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapModalProps = {
    ...abstractModalProps,
    mode: {
        type: String,
        required: false,
        default: ModalMode.Default
    }
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const useBootstrapModal = (props, ctx) => {
    const { close } = useModal(props, ctx);
    const isDrawer = computed(() => props.mode === ModalMode.Drawer);
    return { close, isDrawer };
};
